var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseCell,{attrs:{"align":_vm.align}},[_c(_setup.Money,{staticClass:"money-cell",attrs:{"width":_vm.width,"border-radius":_vm.borderRadius}},[(_vm.isChip)?_c(_setup.ChipStatus,{attrs:{"label":_vm.text,"status":"information"}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }